import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useStyles } from './styles';
import { Box, Button, Grid, TextField, TextareaAutosize, Typography, FormControl, Select, MenuItem, InputLabel, FormControlLabel, Checkbox, CircularProgress, Tooltip, IconButton, ClickAwayListener } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import CancelIcon from '@material-ui/icons/Cancel';
import CloseIcon from '@material-ui/icons/Close';
import HelpIcon from '@material-ui/icons/Help';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { encrypt } from '../../../helpers/encrypt';
import { checkValidEmail, isAdminCheck, getAppSource, getUserType, checkDigitOnly, renderDefaultMsg } from '../../../helpers';
import { submitContactMeRequest, getAllStateList, getLendingGoal, getPrivacySecurityContent } from '../../../actions';
import Cookies from 'js-cookie';
import checkCircle from '../../../assets/Checkmarkpaperless.png';
import CustomBreadcrum from '../../Breadcrum';

export const ContactMe = (props) => {

  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const loanInfo = useSelector(state => state?.loanInfoReducer);
  const [additionalNote, setAdditionalNote] = useState("");
  const [checkboxState, setCheckboxState] = useState(false);
  const [mobileNo, setMobileNo] = useState('');
  const [mobileNoErr, setMobileNoError] = useState("");
  const [errorMessage, setErrorMessage] = useState("")
  const [emailId, setEmailId] = useState('');
  const [emailError, setEmailError] = useState("");
  const [stateData, setStateData] = useState([]);
  const [nonLendingStates, setNonLendingStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [stateErrorMsg, setStateErrorMsg] = useState('');
  const [loanState, setLoanState] = useState('');
  const [lendingGoalData, setLendingGoalData] = useState([]);
  const [mandatoryFields, setMandatoryFields] = useState(false);
  const [isSubmit, isSubmitStatus] = useState(false);
  const [loaderStatus, setloaderStatus] = useState(false);
  const [showServiceBanner, setShowServiceBanner] = useState(true);
  const [consentPopupOpen, setConsentPopupOpen] = useState(false);
  const [consentHtml, setConsentHtml] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [contentHeader, setContentHeader] = useState('Talk to a Loan Officer');
  const [contentSubHeader, setContentSubHeader] = useState("Fill out the short form below and we'll have a licensed Loan Officer reach out within 1 business day.");
  const [successContentValue, setSuccessContentValue] = useState('If you are eligible for refinance or lending options, a member of our lending team will reach out to you.');
  const [openToolTip, setOpenToolTip] = useState(false);
  const mediaQuery = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    getState();
    getLendingGoalData();
    getData();
  }, []);

  const handleTooltipClose = () => {
    setOpenToolTip(false);
  };

  const handleTooltipOpen = () => {
    setOpenToolTip(true);
  };

  const getData = async () => {
    const res = await dispatch(getPrivacySecurityContent('PC037'));
    if (res && res.lstPageContentDetails) {
      const lendingContent = res.lstPageContentDetails.find((item) => String(item?.contentKey || '').toUpperCase() === 'LENDINGCONTENT');
      const consent = res.lstPageContentDetails.find((item) => String(item?.contentKey || '').toUpperCase() === 'CONSENT');
      setContentHeader(lendingContent?.contentHeader || 'Talk to a Loan Officer');
      setContentSubHeader(lendingContent?.contentSubHeader || "Fill out the short form below and we'll have a licensed Loan Officer reach out within 1 business day.");
      setSuccessContentValue(lendingContent?.contentValue || 'If you are eligible for refinance or lending options, a member of our lending team will reach out to you.');
      setConsentHtml(consent?.contentValue || '');
    } else {
      setContentHeader('Talk to a Loan Officer');
      setContentSubHeader("Fill out the short form below and we'll have a licensed Loan Officer reach out within 1 business day.");
      setSuccessContentValue('If you are eligible for refinance or lending options, a member of our lending team will reach out to you.');
      setConsentHtml('');
    }
  }

  const checkboxChangeHandler = (event) => {
    setCheckboxState(event.target.checked)
  }

  const handleMobileNo = (event) => {
    if (checkDigitOnly(event.target.value)) {
     setMobileNo(event.target.value)
    } 
  }

  const handleCommment = (event) => {
    setAdditionalNote(event.target.value)
  }

  const handleCancel = (status) => {
    if (props?.closeCallMePopup) {
      props.closeCallMePopup(status);
      return;
    }
    history.push('/HelpLanding');
  }

  const handleFormStateChange = (event) => {
    setSelectedState(event.target.value);
  }

  const handleConfirm = async () => {
    const hasMissingRequiredFields = checkRequiredValidations();
    const isPhoneValid = validateMobileNo(mobileNo);
    const isEmailValid = validateEmail(emailId);

    if (hasMissingRequiredFields || !isPhoneValid || !isEmailValid) {
      setMandatoryFields(hasMissingRequiredFields)
    } else {
      setloaderStatus(true)
      setMandatoryFields(false)

      const data = {
        "last4SSN": null,
        'dob': null,
        "emailId": emailId ? encrypt(emailId) : null,
        "phoneNo": encrypt(mobileNo),
        "newLoanState": selectedState?.stateCode,
        "callbackReason": loanState,
        "isMilitaryVeteran": null,
        "firstName": firstName,
        "lastName": lastName,
        "isBSICustomer": null,
        "isConsent": checkboxState,
        "description": additionalNote,
        "requestSource": "PreLogin",
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": Cookies.get('publicIp'),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType(),
        "userName": "PreLogin",
      };

      const response = await submitContactMeRequest(data);
      if (response) {
        setloaderStatus(false)
        if (response?.responseData?.lstResponseStatus && (response?.responseData?.lstResponseStatus[0]?.statusCode == 0)) {
          isSubmitStatus(true)
          setErrorMessage("")
        } else {
          setErrorMessage(renderDefaultMsg('400'))
        }
      } else {
        setloaderStatus(false)
        setErrorMessage(renderDefaultMsg('400'))
      }
    }
  }
  
  const calculateCommentLenth = () => {
    const length = additionalNote?.length
    if (isNaN(length)) {
      return 0
    } else {
      return length
    }
  }

  const validateMobileNo = (value) => {
    if (!value) {
      setMobileNoError('');
      return false;
    }
    if (checkDigitOnly(value)) {
      if (value.length === 10) {
        setMobileNoError('');
        return true;
      }
    }
    setMobileNoError('Please enter valid phone number.');
    return false;
  }

  const validateEmail = (value) => {
    const emailValue = value?.trim();
    if (!emailValue) {
      setEmailError('');
      return true;
    }
    if (checkValidEmail(emailValue)) {
      setEmailError('');
      return true;
    } else {
      setEmailError('Please enter valid email address.')
      return false;
    }
  }

  const getState = async () => {
    const response = await getAllStateList();
    if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode == 0) {
      setStateErrorMsg('');
      const nonLendingStateList = (response.stateList || [])
        .filter((item) => item?.isLending === false || item?.isLending === 'false')
        .map((item) => String(item?.stateName || '').trim())
        .filter((name) => name !== '');
      const lendingStates = (response.stateList || [])
        .filter((item) => item?.isLending === true || item?.isLending === 'true')
        .map((item) => ({
          ...item,
          stateName: String(item?.stateName || '').trim()
        }));
      setNonLendingStates(nonLendingStateList);
      setStateData(lendingStates);
    } else if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode == 1001) {
      setStateErrorMsg(response.lstResponseStatus[0].statusDesc);
      setNonLendingStates([]);
    } else {
      setStateErrorMsg(renderDefaultMsg('400'));
      setNonLendingStates([]);
    }
  }

  const openConsentPopup = () => {
    setConsentPopupOpen(true);
  }

  const closeConsentPopup = () => {
    setConsentPopupOpen(false);
  }

  const getLendingGoalData = async () => {
    const response = await getLendingGoal();
    if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode == 0) {
      const list = response.lendingGoalList || [];
      setLendingGoalData(list);
    } else {
      setLendingGoalData([]);
    }
  }

  const checkRequiredValidations = () => {
    if ((loanState == '') || (selectedState == null) || !checkboxState || (firstName.trim() == '') || (lastName.trim() == '') || (mobileNo.trim() == '')) {
      return true
    } else {
      return false
    }
  }

  const handleSaveOnLoansChange = (event) => {
    setLoanState(event.target.value)
  }

  const handleEmailId = (event) => {
    setEmailId(event.target.value)
  }

  const handleServicingCenterClick = () => {
    const servicingCenterRoute = '/HelpLanding';
    history.push(servicingCenterRoute);
  }

  const formatStateNames = (states) => {
    if (!states || states.length === 0) {
      return '';
    }
    if (states.length === 1) {
      return states[0];
    }
    if (states.length === 2) {
      return `${states[0]} and ${states[1]}`;
    }
    return `${states.slice(0, -1).join(', ')} and ${states[states.length - 1]}`;
  }

  const disabledStatesTooltip = nonLendingStates.length
    ? `${formatStateNames(nonLendingStates)} ${nonLendingStates.length === 1 ? 'is' : 'are'} not available at this time.`
    : '';

  const formatPhoneForSuccess = (num) => {
    const value = String(num || '').replace(/\D/g, '').slice(0, 10);
    if (value.length !== 10) {
      return 'Not Provided';
    }
    return `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6, 10)}`;
  }

  return (
    <>
    <Box className={classes.pageWrapper}>
      <Box className={classes.breadcrum}>
        <CustomBreadcrum backPage="Home" backPageLink="/" activePage={contentHeader} />
        <h1 className={classes.pageHeading} color="textPrimary" component='h4'>{contentHeader}</h1>
      </Box>
      <Box className={classes.pageCard}>
        {showServiceBanner && (
          <Box className={classes.serviceStrip}>
            <Typography className={classes.serviceStripText}>
              Looking for help with a loan we service?{' '}
              <span role="button" tabIndex={0} className={classes.serviceStripLink} onClick={handleServicingCenterClick}>Go to Servicing Center</span>
            </Typography>
          </Box>
        )}

          <Box className={classes.cardBody}>
            <Typography className={classes.heroTitle}>{contentHeader}</Typography>
            <Typography className={classes.heroSubTitle}>
              {contentSubHeader}
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography className={classes.fieldLabel}>First Name <span className={classes.required}>*</span></Typography>
                <TextField
                  variant="outlined"
                  placeholder="First Name"
                  value={firstName}
                  onChange={(event) => setFirstName(event.target.value)}
                  className={classes.textBox}
                  inputProps={{ maxLength: 80 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography className={classes.fieldLabel}>Last Name <span className={classes.required}>*</span></Typography>
                <TextField
                  variant="outlined"
                  placeholder="Last Name"
                  value={lastName}
                  onChange={(event) => setLastName(event.target.value)}
                  className={classes.textBox}
                  inputProps={{ maxLength: 20 }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.fieldLabel}>Phone Number <span className={classes.required}>*</span></Typography>
                <TextField
                  variant="outlined"
                  placeholder="Phone Number"
                  value={mobileNo}
                  onChange={handleMobileNo}
                  className={classes.textBox}
                  inputProps={{ maxLength: 10 }}
                />
                {mobileNoErr !== '' && <Typography className={classes.validationError}>{mobileNoErr}</Typography>}
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography className={classes.fieldLabel}>Email <span className={classes.optionalText}>(optional)</span></Typography>
                <TextField
                  variant="outlined"
                  placeholder="Email"
                  value={emailId}
                  onChange={handleEmailId}
                  className={classes.textBox}
                />
                {emailError !== '' && <Typography className={classes.validationError}>{emailError}</Typography>}
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography className={classes.fieldLabel}>What's your goal? <span className={classes.required}>*</span></Typography>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="request-select-label">Select your goal</InputLabel>
                  <Select
                    labelId="request-select-label"
                    id="request-select"
                    name="request"
                    label="Select your goal"
                    className={classes.inputStyle}
                    fullWidth
                    value={loanState}
                    onChange={handleSaveOnLoansChange}
                  >
                    {lendingGoalData.length !== 0 && lendingGoalData.map((item, index) => {
                      const goalValue = String(item?.lendingGoalName || '').replace(/^NULL\s*/i, '').trim();
                      return <MenuItem value={goalValue} key={index}>{goalValue}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box className={classes.propertyLabelRow}>
                  <Typography className={classes.fieldLabel}>Property State <span className={classes.required}>*</span></Typography>
                  {!mediaQuery && <Tooltip title={disabledStatesTooltip} placement="top" arrow>
                    <HelpIcon className={classes.propertyTooltipIcon} />
                  </Tooltip>}
                  {mediaQuery && <ClickAwayListener onClickAway={handleTooltipClose}>
                      <Tooltip
                        title={disabledStatesTooltip}
                        arrow placement="top"
                        open={ openToolTip }
                      >
                      <HelpIcon className={classes.propertyTooltipIcon} onClick={ handleTooltipOpen} />
                    </Tooltip>
                  </ClickAwayListener>}
                </Box>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="state-select-label">Select a state</InputLabel>
                  {stateErrorMsg === '' && (
                    <Select
                      labelId="state-select-label"
                      id="state-select"
                      name="state"
                      label="Select a state"
                      className={classes.inputStyle}
                      value={selectedState}
                      onChange={handleFormStateChange}
                      fullWidth
                    >
                      {stateData.length !== 0 && stateData.map((item, index) => {
                        return (
                          <MenuItem value={item} key={(index - 1) + item.stateCode}>{item.stateName}</MenuItem>
                        )
                      })}
                    </Select>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Typography className={classes.notesLabel}>Anything else we should know? <span className={classes.optionalText}>(optional)</span></Typography>
                <TextareaAutosize
                  onChange={handleCommment}
                  value={additionalNote}
                  placeholder="E.g., best time to call, specific questions, timeline..."
                  maxLength="500"
                  className={classes.textArea}
                />
                <Typography className={classes.textAreaValidation}>{calculateCommentLenth()}/500</Typography>
              </Grid>
            </Grid>

            <Box className={classes.consentSection}>
              <FormControlLabel
                control={<Checkbox checked={checkboxState} onChange={checkboxChangeHandler} name="agree" />}
                label={<Typography className={classes.checkBoxLabel}>By checking this box, you authorize BSI Financial Services to contact you by phone, email, or text regarding loan products. You may opt out at any time. This is not a loan application or commitment to lend. <span className={classes.required}>*</span></Typography>}
              />
              <Typography className={classes.viewconsent} onClick={openConsentPopup}>View Consent</Typography>
            </Box>

            {mandatoryFields && <Typography className={classes.errorMsg}>Please fill * required fields to submit.</Typography>}
            <Typography className={classes.errorMsg}>{errorMessage !== '' ? errorMessage : ''}</Typography>

            <Box className={classes.buttonContainer}>
              <Button
                className={classes.primaryCtaBtn}
                type="submit"
                variant="contained"
                color="primary"
                disabled={loaderStatus || isAdminCheck()}
                onClick={handleConfirm}
              >
                {!loaderStatus ? 'Have a Loan Officer Call Me' : <CircularProgress color='primary' style={{ width: 25, height: 25 }} />}
              </Button>
              <Button
                className={classes.backToSignInBtn}
                variant="outlined"
                color="primary"
                onClick={() => history.push('/')}
              >
                Back to Home
              </Button>
            </Box>
          </Box>
      </Box>

      <Dialog
        open={consentPopupOpen}
        onClose={closeConsentPopup}
        fullWidth
        maxWidth="sm"
        PaperProps={{ className: classes.consentDialogPaper }}
      >
        <Box className={classes.consentDialogHeader}>
          <Typography className={classes.consentDialogTitle}>Consent to Contact</Typography>
          <IconButton className={classes.consentCloseIcon} onClick={closeConsentPopup}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={classes.consentDialogBody}>
          {consentHtml ? (
            <div className={classes.consentHtmlBody} dangerouslySetInnerHTML={{ __html: consentHtml }} />
          ) : (
            <></>
          )}
        </Box>

        <Box className={classes.consentDialogFooter}>
          <Button
            variant="contained"
            color="primary"
            className={classes.consentCloseBtn}
            onClick={closeConsentPopup}
          >
            Close
          </Button>
        </Box>
      </Dialog>

    <Dialog
        open={isSubmit}
        fullWidth
        maxWidth={false}
        hideBackdrop
        PaperProps={{
          classes: { root: classes.dialogStyle },
          style: { maxWidth: 'none', width: 580 }
        }}
      >
        <Box className={classes.root}>
          <IconButton className={classes.allSetcloseIcon} onClick={() => history.push('/')}>
            <CancelIcon />
          </IconButton>
          <Box className={classes.successBody}>
            <img src={checkCircle} alt="Success" className={classes.successCheckImage} />
            <Typography className={classes.successTitle}>You're All Set!</Typography>
            <Typography className={classes.successSubTitle} dangerouslySetInnerHTML={{ __html: successContentValue }} />
            <Box className={classes.successPhonePill}>
              <Typography className={classes.successPhonePillText}>
                Submitted for: <strong>{`${firstName?.toUpperCase() || ''} ${lastName?.toUpperCase() || ''}`.trim()}</strong>
              </Typography>
              <Typography className={classes.successPhonePillText}>
                We'll contact you at: <strong>{formatPhoneForSuccess(mobileNo)}{emailId?.trim() ? ` and ${emailId}` : ''}</strong>
              </Typography>
            </Box>
          </Box>
          <Box className={classes.gotItButton}>
            <Button
              variant='contained'
              color='primary'
              className={classes.gotItBtn}
              onClick={() => history.push('/')}
            >GOT IT</Button>
          </Box>
        </Box>
      </Dialog>
      </Box>
    </>
  )
}
